import React from 'react';
import { useEventDokumentTypMappings } from '@/adapter/opm-cockpit-backend/useEventDokumentTypMappings';
import { Button } from '@/components/ui/button';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';

export const DeactivatedDokumenttypMappingsNotification: React.FC = () => {
  const { data, isLoading } = useEventDokumentTypMappings();

  const pausierteDokumenttypen = (data || []).filter(
    (d) => !d.aktiviert && !(d.deletedAt || d.deletedBy),
  );

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={pausierteDokumenttypen.length > 0 ? 'destructive' : 'ghost'}
          size="sm"
          aria-label={`Pausierte Dokumenttypen (${pausierteDokumenttypen.length})`}
        >
          {isLoading
            ? ''
            : `Pausierte Dokumenttypen: ${pausierteDokumenttypen.length}`}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-2" align="end">
        <div className="text-sm">
          <div className="font-semibold mb-2">Pausierte Dokumenttypen</div>
          {pausierteDokumenttypen.length === 0 ? (
            <div className="text-sm text-muted-foreground">
              Keine deaktivierten Dokumenttypen.
            </div>
          ) : (
            <ul className="space-y-2 max-h-48 overflow-auto">
              {pausierteDokumenttypen.map((d) => (
                <li key={d.externalId}>
                  <div className="font-medium">{d.dokumentTyp}</div>
                  <div className="text-xs text-muted-foreground">
                    {d.eventName}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
};
